import React from 'react';
import { Container } from '@mui/material';
import {
  useProjects,
  useArticles,
  useLifeMetrics,
  useSiteControls,
  useVisitorCounter,
  useSocialChannels,
  useAboutData,
} from '../hooks/useContent';
import { BentoDashboard } from '../components/dashboard/BentoDashboard';

/**
 * Home — Personal Life Dashboard
 *
 * Implements the Implementation Plan specification:
 * - High-density, Grafana-style bento grid of self-contained tiles
 * - Identity Block with @shvms, status beacon, coarse location
 * - Life Pulse: monthly health telemetry (only past completed months)
 * - Project Spotlight: pinned verified projects
 * - Recent Writing: latest articles
 * - Life Graph: multi-perspective channels
 * - Zero fabricated data, no exposed API keys or chat widgets
 */
const Home: React.FC = () => {
  const { projects } = useProjects();
  const { articles } = useArticles();
  const { metrics } = useLifeMetrics();
  const { controls } = useSiteControls();
  const { channels } = useSocialChannels();
  const { about } = useAboutData();
  const visitorCount = useVisitorCounter();

  return (
    <main
      style={{
        position: 'relative',
        zIndex: 1,
        minHeight: 'calc(100vh - 64px)',
        paddingTop: 36,
        paddingBottom: 80,
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <BentoDashboard
          projects={projects}
          articles={articles}
          metrics={metrics}
          controls={controls}
          visitorCount={visitorCount}
          channels={channels}
          about={about}
        />
      </Container>
    </main>
  );
};

export default Home;
